import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 导入Element UI（已替换Element Plus，无兼容性问题）
import './plugins/element'
// 导入全局样式
import './assets/css/global.css'

// Vue 2标准实例创建
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})